import ContentLoader from 'react-content-loader';

interface IProps {}

export const Skeleton: React.FC<IProps> = () => {
	return <div className="skeleton"></div>;
};
